/**
 * Botón de compartir Elife: abre el menú de compartir del dispositivo (Web Share API) o, si no
 * está disponible, copia el enlace al portapapeles y muestra "Enlace copiado" unos segundos.
 */
class ElifeShare extends HTMLElement {
  /** @type {number | undefined} */
  #timer;

  connectedCallback() {
    this.querySelector('.elife-share__button')?.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.querySelector('.elife-share__button')?.removeEventListener('click', this.#handleClick);
    clearTimeout(this.#timer);
  }

  /** @param {MouseEvent} event */
  #handleClick = async (event) => {
    event.preventDefault();
    const url = this.dataset.url || window.location.href;
    const title = this.dataset.title || document.title;

    if (navigator.share) {
      try {
        await navigator.share({ title, url });
        return;
      } catch (error) {
        // El usuario cerró el menú: no hace falta copiar
        if (error instanceof DOMException && error.name === 'AbortError') return;
      }
    }

    try {
      await navigator.clipboard.writeText(url);
      this.#showStatus();
    } catch {
      window.location.href = url;
    }
  };

  #showStatus() {
    const status = /** @type {HTMLElement | null} */ (this.querySelector('.elife-share__status'));
    if (!status) return;
    status.textContent = status.dataset.copiedText ?? '';
    clearTimeout(this.#timer);
    this.#timer = window.setTimeout(() => {
      status.textContent = '';
    }, 2500);
  }
}

if (!customElements.get('elife-share')) {
  customElements.define('elife-share', ElifeShare);
}
